import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState, useAppThunkDispatch } from 'state/store';
import {
  dashboardSelectors,
  getDashboardByIdWithAllRelationships,
  getDashboards,
  resetCurrentDashboard,
  resetDashboardByIdStatus,
  setCurrentDashboardId,
} from 'state/normalized/dashboard/dashboardSlice';
import { clearAllChartData } from 'state/normalized/insights/chartDataSlice';
import { getInsightFilters } from 'state/normalized/insightFilterOptions/insightFilterOptionsSlice';
import { PATHS } from 'utils/constants';
import { useHistory } from 'react-router-dom';
import { showNotification as showSnackbarNotification } from 'state/SnackbarNotification/SnackbarNotificationSlice';
import intl from 'react-intl-universal';

export const useDashboardData = (dashboardId: string) => {
  const dispatch = useAppThunkDispatch();
  const history = useHistory();
  const thisDashboard = useSelector((state: RootState) =>
    dashboardSelectors.selectDashboardById(state, dashboardId)
  );

  const allDashboards = useSelector(dashboardSelectors.selectAll);

  const dashboardStatus = useSelector((state: RootState) =>
    dashboardSelectors.selectDashboardStatusByDashboardId(state, dashboardId)
  );

  useEffect(() => {
    if (dashboardId) {
      dispatch(getDashboardByIdWithAllRelationships({ dashboardId }))
        .unwrap()
        .catch(() => {
          dispatch(
            showSnackbarNotification({
              notificationVariant: 'error',
              notificationTitle: intl.get(
                'DELETE_DASHBOARD_MODAL.NO_ACCESS_SNACKBAR_MESSAGE'
              ),
            })
          );
          history.push(PATHS.DASHBOARDS_LIST_PAGE);
        })
        .then(() => {
          dispatch(getDashboards());
        });
      dispatch(setCurrentDashboardId(dashboardId));
      dispatch(getInsightFilters());
    }
    return () => {
      dispatch(resetCurrentDashboard());
      dispatch(resetDashboardByIdStatus(dashboardId));
      dispatch(clearAllChartData());
    };
  }, [dashboardId, dispatch, history]);

  return {
    thisDashboard,
    allDashboards,
    dashboardStatus,
  };
};
